"use client"
import { iconsMap } from "@/public/icons/iconsMap"
import { sizes } from "@/ui/theme/theme"
import styled from "@emotion/styled"
import { Box, Link } from "@mui/material"
import React from "react"
import { getNonUmbracoUrl } from "utils"

interface CircleIconLinkProps {
  href: string
  children?: React.ReactNode
  className?: string
  iconName?: string
  target?: "_blank" | "_self" | "_parent" | "_top"
}

const StyledCircleIconLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${sizes.baseSingle};
  text-decoration: none;
`
const IconCircleWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: ${sizes.baseHalf};
  border-radius: 30px;
  box-shadow: 0px 4px 30px 0px rgba(35, 32, 32, 0.12);
`

export const CircleIconLink: React.FC<CircleIconLinkProps> = ({
  href,
  children,
  className,
  iconName,
  target = "_self",
}) => {
  const Icon = iconsMap[iconName || "info"]
  return (
    <StyledCircleIconLink
      href={getNonUmbracoUrl(href)}
      target={target}
      className={className}
    >
      <IconCircleWrapper>
        <Icon />
      </IconCircleWrapper>
      {children}
    </StyledCircleIconLink>
  )
}

export default CircleIconLink
